import { useEffect, useState } from 'react'
import { useModal } from './ModalContext'

export default function Prewarm() {
  const [show, setShow] = useState(true)
  const { setIsPrewarm } = useModal()
  useEffect(() => {
    setIsPrewarm(false)
    const t = setTimeout(() => { setShow(false) }, 2000)
    return () => clearTimeout(t)
  }, [])
  if (!show) return null
  return (
    <></>
  )
}


